import React, { Fragment, createRef } from 'react'
import propTypes from 'prop-types'
import moment from 'moment'
import Link from 'next/link'
import styled from 'styled-components'
import TimezoneContext from 'context/timezoneContext'

import Evaluation from '../../../Search/Results/Card/Intro/evaluation'
import { Calendar } from '../../CalendarCartVariant/Calendar'
import { Loader } from '../../Loader'
import { Text } from '../../Text'
import { Column, Row } from '../../Grid'
import { Chevron, VittudeLogo } from '../../Icons'
import { NextImage } from '../../NextImage'
import InformationComplementary from '../../../Psicologo/InformationComplementary'
import InnerNotification from '../../InnerNotification'
import { BookmarkButton } from 'components/v2/Favorite'
import { sendSelectItemEvent } from 'components/shared/DataLayer'

import { getScheduleBySlug } from '../../../../services/professionalService'
import {
  openMap,
  getYouTubeVideoId,
  checkIsMobile,
  convertToDecimalsWhenNeeded,
  getDataContractId
} from '../../../../utils/helpers'
import { formatAppointmentDates, compareStrings } from '../../../../utils/formatters'
import { getProfile } from '../../../../services/auth'
import PsychoPrice from 'components/v2/PsychoPrice/PsychoPrice'

// Página de Favoritos

class SearchPsychologistCardComponent extends React.Component {
  static contextType = TimezoneContext

  state = {
    youtubeVideo: null,
    consultationPrice: 0,
    consultationContractPrice: null,
    location: {},
    schedule: {},
    schedules: {},
    linkPsychologist: '',
    scheduleLoading: true,
    dates: [],
    compareDates: [],
    user: null,
    psychologist: { ...this.props.psychologist, appointments: [] },
    distance: {
      latitude: null,
      longitude: null
    },
    isHideConsultationValue: false,
    hidePresentialConsultation: false,
    activeSymptom: this.props.filters?.symptoms?.[0],
    isCalendarLoading: true,
    currentSchedule: {},
    isLocationChanging: false,
    isScheduleLoading: true,
    startDate: this.props.filters.startDate,
    endDate: this.props.filters.endDate,
    locationSelected: this.props.isMatchMaker
      ? this.props?.matchmakerLocation
      : this.props?.filters.consultation || 'online',
    scheduleOfflineSelected: {
      value: null,
      label: null
    },
    optionsSchedulesOffline: [
      {
        value: '',
        label: ''
      }
    ],
    schedulesDistance: [
      {
        id: '',
        distance: null
      }
    ],
    clinicId: null,
    selectedDate: null,
    queryFilters: null,
    hasSymptom: null
  }

  calendarData = () => {
    const { timezone } = this.context
    const { psychologist, locationSelected } = this.state
    this.setState({
      currentSchedule: {
        coupon: this.props.coupon,
        psico_name: psychologist.name,
        psico_id: psychologist.id,
        is_teleconf: locationSelected === 'online',
        prof_address_slug: psychologist?.distance?.address,
        social_thumb: psychologist.social_thumb,
        crp: psychologist.prof_register,
        evaluations: psychologist.rating ? psychologist.rating.total : 0,
        slug: psychologist.slug,
        type: psychologist.type,
        totalComments: psychologist.evaluations,
        timezone: timezone ?? this.props.timezone,
        timestamp_slot: psychologist.distance ? psychologist.distance.schedule_id : ''
      }
    })
  }

  setPrices = schedule => {
    const hasContractPrice = Boolean(schedule.contract_price?.value >= 0)
    const showContractPrice =
      hasContractPrice && Number(schedule.contract_price?.value) < Number(schedule.price.value)

    this.setState({
      consultationPrice: Number(schedule.price.value),
      consultationContractPrice: Number(schedule.contract_price?.value)
    })
  }

  loadVideo = () => {
    this.setState({
      youtubeVideo: `https://www.youtube.com/embed/${getYouTubeVideoId(
        this.props.psychologist.video_url
      )}?autoplay=1`
    })
  }

  foundSchedule() {
    if (this.props.isMatchMaker) {
      return this.props.psychologist.schedules.find(schedules =>
        this.props.matchmakerLocation === 'offline'
          ? schedules.prof_address
          : !schedules.prof_address
      )
    }
    const found = this.props.psychologist.schedules.find(schedules =>
      this.state.locationSelected === 'presencial'
        ? schedules.prof_address
        : !schedules.prof_address
    )
    return (
      found ||
      this.props.psychologist.schedules.find(schedules =>
        this.state.locationSelected === 'presencial'
          ? !schedules.prof_address
          : schedules.prof_address
      )
    )
  }

  componentDidMount() {
    const { timezone } = this.context
    const origin = this.props.isMatchMaker ? 'matchmaker' : 'busca'
    sessionStorage.setItem('scheduleOrigin', JSON.stringify(origin))
    sessionStorage.removeItem('listName')
    sessionStorage.removeItem('cartType')
    this.calendarData()
    const { psychologist, partnership, coupon, filters } = this.props
    const dataContractId = getDataContractId()
    const user = dataContractId ? dataContractId.integration : getProfile()

    this.setState({
      user: user
    })

    const filter = {
      startDate: moment(filters.startDate).format('YYYYMMDD'),
      endDate: moment(filters.endDate).format('YYYYMMDD'),
      partnership: partnership || '',
      coupon: coupon || '',
      matchms: psychologist.match_category || '',
      consultation: this.state.locationSelected,
      timezone: timezone || filters.timezone || ''
    }
    const queryString = Object.keys(filter)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filter[key])}`)
      .join('&')
    const link = `/psicologo/${psychologist.slug}?${queryString}`

    this.setState({ queryFilters: filter, linkPsychologist: link })

    const found = this.foundSchedule()
    this.setPrices(found)
    this.changeCalendar(found.id)

    this.setState({
      isHideConsultationValue: user?.contract?.features?.hide_consultation_value,
      hidePresentialConsultation:
        typeof user?.contract?.features?.presential_consultation_enabled !== 'undefined' &&
        !user?.contract?.features?.presential_consultation_enabled
    })

    this.state.activeSymptom &&
      this.setState({
        hasSymptom: psychologist.symptoms.some(symptom =>
          compareStrings(symptom, this.state.activeSymptom)
        )
      })
  }

  componentDidUpdate(prevProps) {
    const { timezone } = this.context
    const { filters, psychologist } = this.props
    if (
      filters.startDate !== prevProps.filters.startDate ||
      filters.timezone !== prevProps.filters.timezone
    ) {
      this.calendarData()
      const found = this.foundSchedule()
      this.setPrices(found)
      this.changeCalendar(found.id)

      const filter = {
        ...this.state.queryFilters,
        startDate: filters.startDate,
        timezone: timezone || filters.timezone
      }
      const queryString = Object.keys(filter)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filter[key])}`)
        .join('&')
      const link = `/psicologo/${psychologist.slug}?${queryString}`

      this.setState({ queryFilters: filter, linkPsychologist: link })
    }
    if (
      this.props?.filters?.consultation &&
      this.props?.filters?.consultation !== prevProps?.filters?.consultation
    ) {
      const found = this.foundSchedule()
      this.setPrices(found)
    }
  }

  changeCalendar = async scheduleId => {
    const startDate = moment(this.props.filters.startDate).format('YYYYMMDD')
    const endDate = moment(this.props.filters.startDate)
      .add(4, 'days')
      .format('YYYYMMDD')

    await this.getProfessional(
      startDate,
      endDate,
      this.state.locationSelected !== 'presencial',
      scheduleId
    )

    this.setState({
      startDate,
      endDate
    })
  }

  async getProfessional(initial_date, final_date, virtual, scheduleId) {
    const { timezone } = this.context
    this.setState({ isLocationChanging: true })

    const dataContractId = getDataContractId()
    const user = dataContractId ? dataContractId?.integration : getProfile()

    const userContractId = user?.contract?.id || getDataContractId()?.integration?.contract?.id

    await getScheduleBySlug(
      this.props.psychologist.slug,
      timezone || this.props.filters.timezone,
      initial_date,
      final_date,
      virtual,
      scheduleId,
      undefined,
      userContractId
    )
      .then(response => {
        const appointments = formatAppointmentDates(response.dates, response.schedule)

        this.setState({
          location: response.location,
          dates: response.dates,
          schedule: response.schedule,
          schedules: {
            schedule: response.schedule,
            appointments: appointments
          },
          clinicId: response.schedule_id,
          isCalendarLoading: false
        })

        this.setPrices({ price: response.price, contract_price: response.contract_price })
      })
      .catch(() => {
        this.setState({
          error: true
        })
      })
    this.setState({ isLocationChanging: false, isScheduleLoading: false })
  }

  setNewAppointments() {
    const appointments = formatAppointmentDates(this.state.dates, this.state.schedule)

    const today = 0
    const endOfWeek = 5
    this.setState({
      psychologist: {
        ...this.props.psychologist,
        schedule: this.state.schedule,
        appointments: appointments.splice(today, endOfWeek)
      },
      compareDates: this.state.dates
    })
  }

  sendDatalayer({ dataFrom }) {
    const position = this.props?.psychos?.data?.findIndex(
      psychologist => psychologist?.id === this.props?.psychologist?.id
    )

    const professionalDataForDataLayer = [
      {
        item_name: this.props?.psychologist?.name,
        item_id: this.props?.psychologist?.id,
        item_video: this.props?.psychologist?.video_url,
        price: this.state?.consultationPrice,
        position: position,
        from: dataFrom,
        variant: 'PRINCIPAL'
      }
    ]
    sendSelectItemEvent(professionalDataForDataLayer)
  }
  changeDisabledLoading = isLoading => {
    this.setState({
      isCalendarLoading: isLoading
    })
  }

  handleNextWeek = async () => {
    const schedule = this.foundSchedule()
    this.setState({
      isCalendarLoading: true,
      isScheduleLoading: true
    })

    const calendarStartDate = moment(this.state.startDate)
      .add(5, 'days')
      .format('YYYYMMDD')
    const calendarEndDate = moment(this.state.endDate)
      .add(5, 'days')
      .format('YYYYMMDD')

    await this.getProfessional(
      calendarStartDate,
      calendarEndDate,
      this.state.locationSelected,
      schedule?.id
    )

    this.setState({
      startDate: calendarStartDate,
      endDate: calendarEndDate,
      isScheduleLoading: false,
      isCalendarLoading: false
    })
  }

  handlePreviousWeek = async () => {
    const schedule = this.foundSchedule()
    this.setState({
      isCalendarLoading: true,
      isScheduleLoading: true
    })

    const isFirstDay = moment(this.state.startDate)
      .subtract(5, 'days')
      .isBefore(moment(), 'day')

    const calendarStartDate = isFirstDay
      ? moment().format('YYYYMMDD')
      : moment(this.state.startDate)
          .subtract(5, 'days')
          .format('YYYYMMDD')

    const calendarEndDate = isFirstDay
      ? moment()
          .add(5, 'days')
          .format('YYYYMMDD')
      : moment(this.state.startDate)
          .subtract(1, 'days')
          .format('YYYYMMDD')

    await this.getProfessional(
      calendarStartDate,
      calendarEndDate,
      this.state.locationSelected,
      schedule?.id
    )

    this.setState({
      startDate: calendarStartDate,
      endDate: calendarEndDate,
      isScheduleLoading: false,
      isCalendarLoading: false
    })
  }

  render() {
    const { psychologist, isMatchMaker } = this.props
    const {
      youtubeVideo,
      locationSelected,
      isLocationChanging,
      isScheduleLoading,
      currentSchedule,
      isCalendarLoading,
      schedules,
      clinicId,
      selectedDate,
      hasSymptom,
      startDate,
      endDate
    } = this.state
    const showingMiniCv =
      psychologist?.mini_cv?.length > 254
        ? `${psychologist?.mini_cv.slice(0, 255)}...`
        : psychologist?.mini_cv

    if (this.state.dates !== this.state.compareDates) {
      this.setNewAppointments()
    }

    const previousDay = moment(startDate)
      .subtract(1, 'day')
      .isBefore(moment(), 'day')

    const lastDay = moment(endDate).isSameOrAfter(
      moment()
        .add(3, 'M')
        .format('YYYYMMDD')
    )

    return (
      <div className='search-psychologist-card bg-white w-100'>
        <div className='d-flex flex-column flex-1'>
          <div className='d-flex'>
            <div className='search-psychologist-card__profile-section'>
              <Row mb='28px'>
                <PsychoImage
                  itemProp='image'
                  itemType='http://schema.org/image'
                  src={psychologist.social_thumb || '/static/images/psicologo-sem-foto.png'}
                  alt={psychologist.name}
                  width={100}
                  height={100}
                />
              </Row>
              {checkIsMobile(769) && (
                <BookmarkButton
                  professionalId={psychologist.id}
                  professionalSlug={psychologist.slug}
                  isLiked={psychologist.is_liked}
                />
              )}
              {locationSelected === 'presencial' &&
                psychologist.distance &&
                JSON.stringify(psychologist.distance) &&
                this.state.distance && (
                  <span
                    className='psychologist-distance'
                    onClick={() =>
                      openMap(
                        psychologist?.location
                          ? psychologist
                          : { ...psychologist, location: this.state.location }
                      )
                    }
                  >
                    <NextImage
                      height={20}
                      width={20}
                      src='/static/images/mapa-azul.svg'
                      alt='map pin'
                    />
                    {` ${this.state.distance} km`}
                  </span>
                )}

              <PsychoPrice
                originalPrice={this.state.consultationPrice}
                contractPrice={this.state.consultationContractPrice}
              />
              <Evaluation psycho={psychologist} numbertotal={psychologist.rating.total} />
              <span className='appointment-duration'>50 min</span>
            </div>
            <div className='psychologist-info'>
              <Row width='100%' justifyContent='space-between'>
                <span
                  className='psychologist-name'
                  itemProp='name'
                  cy_id='psychologist'
                  onClick={() => {
                    this.sendDatalayer({
                      dataFrom: 'psychologist-name'
                    })
                    this.props.onNavigateToPsychologist()
                  }}
                >
                  <Link href={this.state.linkPsychologist} passHref>
                    <PsychologistName>{psychologist.name}</PsychologistName>
                  </Link>

                  {psychologist.number_of_consultations >= 10 && (
                    <Column display='inline' ml='10px'>
                      <NextImage
                        src='/static/images/verified.png'
                        alt='Psicólogo Verificado'
                        width={14}
                        height={14}
                      />
                    </Column>
                  )}
                </span>
                {!checkIsMobile(769) && (
                  <BookmarkButton
                    professionalId={psychologist.id}
                    professionalSlug={psychologist.slug}
                    isLiked={psychologist.is_liked}
                  />
                )}
              </Row>
              <span className='psychologist-crp'>CRP {psychologist.prof_register}</span>
              {this.state.activeSymptom && (
                <div className='psychologist-symptoms'>
                  {hasSymptom && <span className='sympton'>{this.state.activeSymptom}</span>}
                  {psychologist.symptoms.length > 1 && (
                    <button
                      className='link-to-profile my-2'
                      onClick={() => {
                        this.sendDatalayer({
                          dataFrom: 'psychologist-symptoms'
                        })
                        this.props.onNavigateToPsychologist()
                      }}
                    >
                      <Link href={this.state.linkPsychologist} passHref>
                        <Text color='#709fef' variant='small' fontWeight='600'>
                          {hasSymptom
                            ? `+${psychologist.symptoms.length - 1} especialidades`
                            : `${psychologist.symptoms.length} especialidades`}
                        </Text>
                      </Link>
                    </button>
                  )}
                </div>
              )}
              {!psychologist.video_url && (
                <Fragment>
                  <span className='about-psychologist__title'>Sobre mim</span>
                  <span className='about-psychologist__body'>{showingMiniCv}</span>
                  <button
                    className='link-to-profile my-2'
                    onClick={() => {
                      this.props.onNavigateToPsychologist()
                    }}
                  >
                    <Link href={this.state.linkPsychologist} passHref>
                      <Text
                        as='a'
                        href={this.state.linkPsychologist}
                        color='#FF7708'
                        variant='small'
                        fontWeight='600'
                        onClick={() =>
                          this.sendDatalayer({
                            dataFrom: 'about-psychologist'
                          })
                        }
                      >
                        Ver perfil completo
                      </Text>
                    </Link>
                  </button>
                </Fragment>
              )}

              <InformationComplementary
                languages={psychologist.languages}
                delta_joined={psychologist.delta_joined}
                number_of_consultations={psychologist.number_of_consultations}
                slug={psychologist.slug}
                professionalHash={psychologist.professional_hash}
              />
            </div>
          </div>
          <div className='d-flex flex-1'>
            <div className='about-psychologist-item' />
            <div className='about-psychologist w-100 flex-1'>
              {psychologist.video_url && (
                <Fragment>
                  <div className='youtube-video' onClick={this.loadVideo}>
                    {youtubeVideo ? (
                      <iframe
                        width='100%'
                        height='262'
                        className='psychologist-video'
                        src={youtubeVideo}
                      />
                    ) : (
                      <Row width='100%' position='relative'>
                        <Row
                          position='absolute'
                          width='100%'
                          height='100%'
                          justifyContent='center'
                          alignItems='center'
                        >
                          <NextImage
                            className='youtube-video__play-icon'
                            src='/static/images/play-psychologist-video-icon.svg'
                            width={50}
                          />
                        </Row>
                        <div className='layer' />
                        <div className='youtube-image__container'>
                          <NextImage
                            layout='fill'
                            objectFit='cover'
                            display='relative'
                            className='youtube-image'
                            src={`https://i.ytimg.com/vi/${getYouTubeVideoId(
                              psychologist.video_url
                            )}/hqdefault.jpg`}
                            onClick={() => {
                              this.sendDatalayer({
                                dataFrom: 'video-psychologist'
                              })
                            }}
                          />
                        </div>
                      </Row>
                    )}
                  </div>
                  <button
                    className='link-to-profile my-2'
                    onClick={() => this.props.onNavigateToPsychologist()}
                  >
                    <Link href={this.state.linkPsychologist} passHref>
                      <Text
                        as='a'
                        href={this.state.linkPsychologist}
                        color='#FF7708'
                        variant='small'
                        fontWeight='600'
                      >
                        Ver perfil completo
                      </Text>
                    </Link>
                  </button>
                  {!checkIsMobile(769) && (
                    <InnerNotification
                      dataType={'billet-notice'}
                      selectedDate={selectedDate}
                      setSelectedDate={value => this.setState({ selectedDate: value })}
                      variant='inSearchCardVideo'
                      timezone={this.props.query.timezone}
                    />
                  )}
                </Fragment>
              )}
            </div>
            {!psychologist.video_url && !checkIsMobile(769) && (
              <InnerNotification
                dataType={'billet-notice'}
                selectedDate={selectedDate}
                setSelectedDate={value => this.setState({ selectedDate: value })}
                variant='inSearchCard'
                timezone={this.props.query.timezone}
              />
            )}
          </div>
        </div>
        <div className='calendar-psychologist'>
          <Fragment>
            <Column width={['auto', '300px', '300px']}>
              {isLocationChanging ? (
                <Row justifyContent='center' alignItems='center' height='303px'>
                  <Loader width='60px' />
                </Row>
              ) : (
                <Column position='relative'>
                  {!isScheduleLoading && (
                    <Row
                      alignSelf='center'
                      width='115%'
                      justifyContent='space-between'
                      position='absolute'
                      top={10}
                      pl={[0, '-8px']}
                      pr={[2, 0, 0]}
                    >
                      <Chevron
                        variant='right'
                        color={previousDay ? 'white' : '#FF7708'}
                        cursor={previousDay ? 'default' : 'pointer'}
                        onClick={previousDay ? () => {} : this.handlePreviousWeek}
                      />
                      <Chevron
                        variant='left'
                        color={lastDay ? 'white' : '#FF7708'}
                        cursor={lastDay ? 'default' : 'pointer'}
                        onClick={lastDay ? () => {} : this.handleNextWeek}
                        style={{ marginRight: '22px' }}
                      />
                    </Row>
                  )}
                  <Calendar
                    id='calendar-id'
                    className='calendar-class'
                    matchCategory={psychologist?.match_category}
                    isMatchMaker={isMatchMaker}
                    currentSchedule={currentSchedule}
                    isSearch={true}
                    showWarnings={false}
                    isLoading={isCalendarLoading}
                    consultationAmount={1}
                    schedules={schedules}
                    clinicId={clinicId}
                    selectedDate={selectedDate}
                    setSelectedDate={value => this.setState({ selectedDate: value })}
                    linkPsychologist={this.state.linkPsychologist}
                    setIsDisabledLoading={this.changeDisabledLoading}
                    psychologistInfo={psychologist}
                    handleMultipleScheduling={this.props.handleMultipleScheduling}
                  />
                </Column>
              )}
            </Column>
          </Fragment>
        </div>
      </div>
    )
  }
}

const PsychoImage = styled(NextImage)`
  border-radius: 50%;
`

const PsychologistName = styled.a`
  color: #ff7708;
  &:hover {
    color: #ff7708;
  }
`

const SearchPsychologistCard = React.memo(
  SearchPsychologistCardComponent,
  (next, prev) => JSON.stringify(prev) === JSON.stringify(next)
)

export { SearchPsychologistCard }

SearchPsychologistCard.propTypes = {
  psychologist: propTypes.object.isRequired,
  onNavigateToPsychologist: propTypes.func.isRequired,
  timezone: propTypes.string.isRequired
}
